"use strict";

var _typeof = require("@babel/runtime-corejs3/helpers/typeof");

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ActionButton = _interopRequireDefault(require("../ActionButton/ActionButton"));

function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { _Object$defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var NextButton = function NextButton(_ref) {
  var className = _ref.className,
      children = _ref.children,
      handleClick = _ref.handleClick,
      _ref$enable = _ref.enable,
      enable = _ref$enable === void 0 ? true : _ref$enable,
      hideNextButton = _ref.hideNextButton,
      langStrings = _ref.langStrings,
      id = _ref.id;
  return /*#__PURE__*/_react.default.createElement(_ActionButton.default, {
    enable: enable,
    title: children || langStrings.buttons.nextButton,
    className: className,
    handleClick: handleClick,
    id: id
  });
};

NextButton.propTypes = {
  className: _propTypes.default.string,
  children: _propTypes.default.any,
  handleClick: _propTypes.default.func,
  hideNextButton: _propTypes.default.bool,
  enable: _propTypes.default.bool,
  langStrings: _propTypes.default.object,
  id: _propTypes.default.string
};

var _default = (0, _styledComponents.default)(NextButton).withConfig({
  displayName: "NextButton",
  componentId: "f4jzaw-0"
})(["float:right;", ""], function (props) {
  return props.hideNextButton && (0, _styledComponents.css)(["visibility:hidden;"]);
});

exports.default = _default;